Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontRegular = _STYLES$useStyles.fontRegular,
    paragraph = _STYLES$useStyles.paragraph,
    spacing = _STYLES$useStyles.spacing;
  var _isBp = bp.is([bp.tablet, bp.desktop]);
  var _gap = (0, _styles.getREM)(0.5);
  if (bp.tablet) {
    _gap = (0, _styles.getREM)(0.375);
  }
  if (bp.desktop) {
    _gap = (0, _styles.getREM)(0.75);
  }
  var _columnWidth = '100%';
  var _2ColumnWidth = '100%';
  if (bp.tablet) {
    _columnWidth = (0, _styles.getREM)(7);
    _2ColumnWidth = (0, _styles.getREM)(10);
  }
  if (bp.desktop) {
    _columnWidth = (0, _styles.getREM)(8);
    _2ColumnWidth = (0, _styles.getREM)(12);
  }
  var leaderboardWrapper = {
    maxWidth: _styles.STYLES.grid.maxTextWidth,
    width: '100%',
    alignSelf: 'center'
  };
  if (!_isBp) {
    leaderboardWrapper.maxWidth = _styles.STYLES.grid.maxBoxWidth;
  }
  if (_reactNative.Platform.OS === 'android') {
    leaderboardWrapper.paddingHorizontal = (0, _styles.getREM)(0.75);
  }
  var columnHeadings = {
    backgroundColor: COLORS.paper,
    position: 'relative',
    borderTopLeftRadius: (0, _styles.getREM)(1),
    borderTopRightRadius: (0, _styles.getREM)(1),
    paddingHorizontal: _gap,
    flexDirection: 'row',
    marginBottom: (0, _styles.getREM)(-3)
  };
  if (!_isBp) {
    columnHeadings.display = 'none';
  }
  var columnHeading = {
    minHeight: (0, _styles.getREM)(7),
    justifyContent: 'center',
    width: _columnWidth,
    paddingHorizontal: _gap,
    paddingBottom: (0, _styles.getREM)(3)
  };
  var columnHeadingTitle = Object.assign({}, fontSemiBold, {
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    textAlign: 'center',
    position: 'relative',
    zIndex: 1
  });
  if (bp.is([bp.tablet, bp.desktop])) {
    columnHeadingTitle.fontSize = _styles.STYLES.fontSize.s;
    columnHeadingTitle.lineHeight = _styles.STYLES.lineHeight.s;
  }
  var columnHeadingSubTitle = Object.assign({}, columnHeadingTitle, fontRegular, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs
  });
  var rowContainer = {
    marginBottom: spacing.xl
  };
  var rows = Object.assign({
    flex: 1,
    backgroundColor: colors.background,
    position: 'relative',
    borderRadius: (0, _styles.getREM)(1)
  }, _reactNative.Platform.select({
    web: {
      boxShadow: "0 ".concat((0, _styles.getREM)(0.125), " ").concat((0, _styles.getREM)(0.5), " ").concat((0, _styles.getREM)(0.25), " ").concat((0, _styles.getOpaqueColor)(COLORS.aubergine, 0.15))
    },
    android: {
      elevation: 4,
      shadowColor: COLORS.aubergine
    },
    ios: {
      shadowOpacity: 0.15,
      shadowRadius: (0, _styles.getREM)(0.25),
      shadowOffset: {
        width: (0, _styles.getREM)(0.125),
        height: (0, _styles.getREM)(0.5)
      },
      shadowColor: COLORS.aubergine
    }
  }));
  var row = {
    flexDirection: 'row',
    minHeight: (0, _styles.getREM)(5),
    paddingHorizontal: _gap,
    borderBottomColor: COLORS.steam,
    borderBottomWidth: 1
  };
  if (!_isBp) {
    row.flexDirection = 'column';
    row.alignItems = 'center';
    row.paddingVertical = spacing.normal;
  }
  var finalRow = {
    borderBottomWidth: 0
  };
  var rowCell = {
    alignItems: 'center',
    width: _columnWidth
  };
  if (_isBp) {
    rowCell.paddingHorizontal = _gap;
    rowCell.justifyContent = 'center';
  }
  if (!_isBp) {
    rowCell.marginVertical = _gap;
    rowCell.paddingHorizontal = _gap;
    rowCell.flexDirection = 'row';
    rowCell.justifyContent = 'space-between';
  }
  var rowCellContent = {
    position: 'relative',
    flexShrink: 1
  };
  var rowCellHeading = {};
  if (_isBp) {
    rowCellHeading.display = 'none';
  }
  var individualRowCellHeading = {
    rank: {
      display: 'none'
    }
  };
  var rowCellHeadingTitle = Object.assign({}, fontSemiBold, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.brand
  });
  var rowCellHeadingSubTitle = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs,
    color: colors.brand
  });
  var rowCellText = Object.assign({}, fontSemiBold, {
    color: colors.brand,
    fontSize: paragraph.fontSize,
    lineHeight: paragraph.lineHeight,
    position: 'relative',
    zIndex: 1,
    width: '100%',
    alignItems: 'flex-start'
  });
  if (!_isBp) {
    rowCellText.textAlign = 'center';
  }
  var rowCellSecondaryText = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.brand
  });
  if (!_isBp) {
    rowCellSecondaryText.textAlign = 'center';
  }
  var defaultSortColumnStyling = {
    backgroundColor: colors.focus,
    borderTopLeftRadius: (0, _styles.getREM)(1),
    borderTopRightRadius: (0, _styles.getREM)(1),
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 0
  };
  var defaultSortColumnCellStyling = Object.assign({}, defaultSortColumnStyling, {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    opacity: 0.3
  });
  if (!_isBp) {
    defaultSortColumnCellStyling.left = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(_gap, ")") : -1 * _gap;
    defaultSortColumnCellStyling.right = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(_gap, ")") : -1 * _gap;
    defaultSortColumnCellStyling.top = _reactNative.Platform.OS === 'web' ? "calc(-0.5 * ".concat(_gap, ")") : -1 * _gap;
    defaultSortColumnCellStyling.bottom = _reactNative.Platform.OS === 'web' ? "calc(-0.5 * ".concat(_gap, ")") : -1 * _gap;
  }
  var defaultSortColumnCellStyling_highlighted = {
    opacity: 1
  };
  if (_isBp) {
    defaultSortColumnCellStyling_highlighted.marginTop = (0, _styles.getREM)(-0.25);
    defaultSortColumnCellStyling_highlighted.marginBottom = (0, _styles.getREM)(-0.25);
  }
  if (!_isBp) {
    defaultSortColumnCellStyling_highlighted.left = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(_gap, " + ").concat((0, _styles.getREM)(-0.5), ")") : -1 * _gap + (0, _styles.getREM)(-0.5);
    defaultSortColumnCellStyling_highlighted.right = _reactNative.Platform.OS === 'web' ? "calc(-1 * ".concat(_gap, " + ").concat((0, _styles.getREM)(-0.5), ")") : -1 * _gap + (0, _styles.getREM)(-0.5);
  }
  var highlightedRow = Object.assign({
    backgroundColor: COLORS.whisper,
    position: 'absolute',
    top: (0, _styles.getREM)(-0.25),
    left: (0, _styles.getREM)(-0.5),
    right: (0, _styles.getREM)(-0.5),
    bottom: (0, _styles.getREM)(-0.25),
    borderRadius: (0, _styles.getREM)(1),
    borderColor: COLORS.steam,
    borderWidth: (0, _styles.getREM)(0.0625),
    borderStyle: 'solid'
  }, _reactNative.Platform.select({
    web: {
      boxShadow: "0 ".concat((0, _styles.getREM)(0.125), " ").concat((0, _styles.getREM)(0.125), " ").concat((0, _styles.getOpaqueColor)(COLORS.aubergine, 0.2))
    },
    android: {
      elevation: 4,
      shadowColor: COLORS.aubergine
    },
    ios: {
      shadowOpacity: 0.2,
      shadowRadius: (0, _styles.getREM)(0.125),
      shadowOffset: {
        width: 0,
        height: (0, _styles.getREM)(0.125)
      },
      shadowColor: COLORS.aubergine
    }
  }));
  var pagination = {
    marginBottom: spacing.xl
  };
  var leaderboardHeading = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.m,
    lineHeight: _styles.STYLES.lineHeight.m,
    color: colors.brand,
    marginBottom: spacing.xl,
    textAlign: 'center'
  });
  var columnHeadingTitleFirst = {
    textAlign: 'left'
  };
  var rank = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s,
    color: colors.brand
  });
  var loading = {
    minHeight: (0, _styles.getREM)(10)
  };
  var individualHeadingStyle = {};
  var individualCellStyle = {};
  individualHeadingStyle.rank = {
    flex: 1
  };
  individualCellStyle.rank = {
    width: 'auto'
  };
  individualHeadingStyle.name = {
    flex: 0
  };
  individualCellStyle.name = {
    flex: 1,
    alignItems: 'flex-start',
    paddingVertical: _gap,
    width: 'auto'
  };
  individualHeadingStyle.avatar = {
    flex: 0
  };
  individualCellStyle.avatar = {
    width: 'auto'
  };
  individualHeadingStyle.total_step_activity = {
    width: _2ColumnWidth
  };
  individualCellStyle.total_step_activity = {
    width: _2ColumnWidth
  };
  individualHeadingStyle.total_completed_steps = {
    width: _2ColumnWidth
  };
  individualCellStyle.total_completed_steps = {
    width: _2ColumnWidth
  };
  individualHeadingStyle.average_step_activity = {
    width: _2ColumnWidth
  };
  individualCellStyle.average_step_activity = {
    width: _2ColumnWidth
  };
  individualHeadingStyle.average_completed_steps = {
    width: _2ColumnWidth
  };
  individualCellStyle.average_completed_steps = {
    width: _2ColumnWidth
  };
  var emptyMessage = Object.assign({}, fontRegular, {
    fontSize: _styles.STYLES.fontSize.normal,
    lineHeight: _styles.STYLES.lineHeight.normal,
    color: colors.brand,
    backgroundColor: COLORS.whisper,
    textAlign: 'center',
    padding: spacing.normal,
    marginVertical: spacing.l,
    borderRadius: (0, _styles.getREM)(1),
    width: '100%',
    maxWidth: _styles.STYLES.grid.maxBoxWidth,
    alignSelf: 'center',
    overflow: 'hidden'
  });
  var styles = _reactNative.StyleSheet.create({
    columnHeadings: columnHeadings,
    columnHeading: columnHeading,
    columnHeadingTitle: columnHeadingTitle,
    columnHeadingSubTitle: columnHeadingSubTitle,
    row: row,
    rowCell: rowCell,
    rowCellContent: rowCellContent,
    rowCellHeading: rowCellHeading,
    individualRowCellHeading: individualRowCellHeading,
    rowCellHeadingTitle: rowCellHeadingTitle,
    rowCellHeadingSubTitle: rowCellHeadingSubTitle,
    rowContainer: rowContainer,
    rows: rows,
    rowCellText: rowCellText,
    rowCellSecondaryText: rowCellSecondaryText,
    leaderboardWrapper: leaderboardWrapper,
    defaultSortColumnStyling: defaultSortColumnStyling,
    defaultSortColumnCellStyling: defaultSortColumnCellStyling,
    defaultSortColumnCellStyling_highlighted: defaultSortColumnCellStyling_highlighted,
    finalRow: finalRow,
    columnHeadingTitleFirst: columnHeadingTitleFirst,
    individualHeadingStyle: individualHeadingStyle,
    individualCellStyle: individualCellStyle,
    highlightedRow: highlightedRow,
    pagination: pagination,
    leaderboardHeading: leaderboardHeading,
    rank: rank,
    loading: loading,
    emptyMessage: emptyMessage
  });
  return {
    styles: styles
  };
};